import React from 'react';
import PropTypes from 'prop-types';
import Portal from 'react-portal';
import cn from "classnames";

import SupportingMenu from 'components/SupportingMenu';

import cross from './cross.svg';

import css from './MobileMenu.module.scss';

class BlockMenu extends React.Component {
    static propTypes = {
        link: PropTypes.string,
        linkText: PropTypes.string,
        menuItems: PropTypes.arrayOf(PropTypes.shape({
            href: PropTypes.string,
            text: PropTypes.string,
        })),
    }

    state = {
        open: false
    }

    render() {
        const {
            link,
            linkText,
            menuItems
        } = this.props;

        const {
            open
        } = this.state;

        return (
            <li>
                <header>
                    <h2>
                        {link
                            ? <a href={link}>{linkText}</a>
                            : linkText
                        }
                    </h2>
                    {menuItems && menuItems.length > 0 && (
                        <button onClick={() => this.setState({ open: !open })}>
                            {open ? '-' : '+'}
                        </button>
                    )}
                </header>
                {menuItems && menuItems.length > 0 && (
                    <ul className={css.yadda} style={{ display: open ? 'block' : 'none' }}>
                        {menuItems.map((item, i) => (
                            <li key={i}><a href={item.href}>{item.text}</a></li>
                        ))}
                    </ul>
                )}
            </li>
        );
    }
}

class MobileMenu extends React.PureComponent {
    static propTypes = {
        open: PropTypes.bool.isRequired,
        closeMenu: PropTypes.func.isRequired,
        menu: PropTypes.array,
        supportingMenu: PropTypes.array,
        searchLink: PropTypes.string.isRequired,
        languages: PropTypes.array,
        searchLabel: PropTypes.string.isRequired,
        withCustomLogo: PropTypes.bool,
        openQuickSearchFormBtnAriaLabel: PropTypes.string.isRequired,
        closeQuickSearchFormBtnAriaLabel: PropTypes.string.isRequired,
    }

    state = {
        active: null,
    }

    _handleOnClick = e => {
        const { index } = e.currentTarget.dataset;
        const { active } = this.state;

        if(active == index) {
            this.setState({ active: null });
        } else {
            this.setState({ active: index });
        }
    }

    onClick = (id) => {
        this.setState({ isActive: this.state.isActive === id ? null : id });
    }

    render() {
        const {
            menu,
            supportingMenu,
            open,
            closeMenu,
            searchLink,
            languages,
            searchLabel,
            withCustomLogo,
            openQuickSearchFormBtnAriaLabel,
            closeQuickSearchFormBtnAriaLabel
        } = this.props;

        const {
            isActive,
            active,
        } = this.state;

        return (
            <Portal isOpened={open}>
                <div 
                    className={cn(css.menu, {
                        "with-custom-logo": withCustomLogo
                    })}
                >
                    <nav>
                        <ul>
                            {menu.map((m, i) => (
                                <li key={i} className={css.item}>
                                    <header>
                                        <h1>
                                            {m.link
                                                ? <a href={m.link}>{m.linkText}</a>
                                                : m.linkText
                                            }
                                        </h1>
                                        {m.columns && m.columns.length > 0 && (
                                            <button
                                                data-index={i}
                                                onClick={this._handleOnClick}
                                            >{active == i ? '-' : '+'}</button>
                                        )}
                                    </header>
                                    {m.columns && m.columns.length > 0 && m.columns.map((column, ci) => (
                                        <ul key={ci} style={{ display: active == i ? 'block' : 'none' }}>
                                            {column.map((block, i) => (
                                                <BlockMenu
                                                    key={i}
                                                    {...block}
                                                />
                                            ))}
                                        </ul>
                                    ))}
                                </li>
                            ))}
                        </ul>
                    </nav>
                    <SupportingMenu
                        menu={supportingMenu}
                        searchLabel={searchLabel}
                        searchLink={searchLink}
                        languages={languages}
                        onClick={this.onClick}
                        isActiveOnMobile={true}
                        isActive={isActive}
                        withCustomLogo={withCustomLogo}
                        openQuickSearchFormBtnAriaLabel={openQuickSearchFormBtnAriaLabel}
                        closeQuickSearchFormBtnAriaLabel={closeQuickSearchFormBtnAriaLabel}
                    />
                    <button className={css.close} onClick={closeMenu}>
                        <img src={cross} />
                    </button>
                </div>
            </Portal>
        );
    }
}

export default MobileMenu;



// WEBPACK FOOTER //
// ./src/components/MobileMenu/MobileMenu.jsx